define('../app/fukit/configuration/active.app.enforcement.configuration',['require','exports','module','jquery','../config','datakit/datakit','../view/block/product.deactivated.dimmer.view'],function(require, exports, module) {
  //prettier-ignore
  var jQuery                       = require('jquery'),
      config                       = require('../config'),
      urlTemplate                  = require('datakit/datakit').url.template,
      ProductDeactivatedDimmerView = require('../view/block/product.deactivated.dimmer.view');

  var baseApiRUL = config.get('admin.api.base.url');

  var ActiveAppEnforcementConfiguration = {
    radioEvents: {
      'app configure': 'onAppConfigure',
    },

    apiUrlRoot: baseApiRUL ? baseApiRUL : '/api/v1',

    onAppConfigure: function(app) {
      if (config.get('VERIFY_APP_IS_ACTIVE')) {
        app.registerReadyInterceptor(this.verifyAppIsActive, this);
      }
    },

    verifyAppIsActive: function() {
      var self = this;
      return new Promise(function(resolve) {
        jQuery.ajax({
          contentType: 'application/json',
          url: urlTemplate(self.apiUrlRoot + '/tenant/tenant/product/:productName/active', {
            productName: config.get('APP_NAME'),
          }),
          success: resolve,
          error: function() {
            self.showProductDeactivatedDimmer();
            // never resolve on error so that the app
            // will not load
          },
        });
      });
    },

    showProductDeactivatedDimmer: function() {
      new ProductDeactivatedDimmerView({ visible: true });
    },
  };

  module.exports = ActiveAppEnforcementConfiguration;
});

